/**
 * The server's ONE definition of renewable — `GeltDto.isRenewable()`: accrues AND is capped, all
 * three columns strictly positive. The cap is a product rule, not arithmetic: an uncapped accrual
 * would grow without bound. The minigame Cloud Functions' `resolveGelt` gates on the identical
 * shape (`regen_max > 0 && regen_amount > 0 && regen_interval_sec > 0`), which is what keeps the
 * three runtimes agreeing.
 *
 * Lives in its own module rather than inside GeltEditPage so it is importable — and therefore
 * testable — without pulling in the page's router and MUI imports.
 *
 * GeltEditPage derived this from `regenIntervalSec` alone, making the admin a SECOND definition
 * that disagreed with the server. Because the same flag gates which fields the page submits, that
 * let one Save write a null cap, which the server reads as non-renewable — regeneration off for
 * every player holding the gelt, and `openingAmount()` 0 regardless of "Starts Full".
 */
export const isRenewableConfig = g => g.regenMax > 0 && g.regenAmount > 0 && g.regenIntervalSec > 0;
